// Mirrors TodoTask::ACTION_* on the BE (SnapPea app/models/todo_task.rb).
export const TODO_TASK_ACTIONS = {
  CONFIRM_EVENT_ATTENDANCE: 'Confirm Event Attendance',
  SUBMIT_RESTAURANT_AVAILABILITY: 'Submit Restaurant Availability',
} as const;

export type TodoTaskAction = (typeof TODO_TASK_ACTIONS)[keyof typeof TODO_TASK_ACTIONS];
